import React, { useEffect, useState, useContext, createRef } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import lottie from "lottie-web"
import AppContext from "../components/Context"

import { family, size } from "../elements/font"
import animationPlus from "../animations/plus.json"
import animationMoins from "../animations/moins.json"
import { RichText } from "prismic-reactjs"

const CadreContainer = styled.div`
  width: ${props => (props.green ? "100%" : "75%")};
  height: ${props =>
    props.big
      ? props.green
        ? `calc(${props.baseHeight} + ${props.height - 50}px)`
        : `${props.height}px`
      : props.baseHeight};
  transition: height 0.5s ease;
  ${props => !props.green && "border: 2px solid black;"}
  ${props =>
    props.green &&
    "box-shadow: -2px -4px 20px rgba(119, 173, 123, 0.15), 2px 4px 20px rgba(119, 173, 123, 0.15); display: flex; align-items: center; background: white;"}
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: 800px) {
    width: 100%;
    height: ${props => (props.big ? `${props.height}px` : "calc(25vh + 40px)")};
    min-height: 220px;
    transition: height 0.5s ease;
    z-index: 5;
    ${props =>
      props.green &&
      `
        flex-direction: column;
        align-items: center;
        height: auto;
    `}
  }

  @media screen and (max-width: 900px) and (max-height: 430px) {
    height: ${props =>
      props.big
        ? props.green
          ? `calc(${props.baseHeight} + ${props.height -
              (props.isOffre ? 50 : 0)}px)`
          : `${props.height}px`
        : props.isOffre
        ? "43vh"
        : "70vh"};
  }
`

const ContainerAnimate = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  ${props => props.green && "align-items: flex-end;"}
  position: absolute;
  top: 0;
  transition: transform 0.5s ease-out;
  &.slide {
    transform: translateY(-50%);
  }
  @media only screen and (max-width: 800px) {
    position: relative;
    height: auto;
    ${props =>
      props.green &&
      `
            align-items: center;
        `}
  }

  @media screen and (max-width: 900px) and (max-height: 430px) {
    align-items: center;
  }
`

const TextCardContainer = styled.div`
  font-size: ${size.S};
  line-height: 35px;
  font-family: ${family.Archivo};
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 50%;
  width: ${props => (props.green ? "80%" : "100%")};
  & > p {
    margin: 0;
    font-size: 1.2vw;
    padding: 0 1vw;
  }
  &:nth-child(1) {
    height: 40vh;
    vertical-align: middle;
  }
  &:not(:nth-child(1)) {
    height: auto;
  }
  @media only screen and (max-width: 800px) {
    font-size: 11px;
    line-height: 16px;
    padding: 0 5px;
    box-sizing: border-box;
    margin-bottom: 10vh;
    & > p {
      font-size: 12px;
      line-height: 16px;
    }
    &:nth-child(1) {
      margin-top: 1vh;
      height: 15vh;
      vertical-align: middle;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      ${props => props.big && "margin-bottom: 0;"}
    }
    &:not(:nth-child(1)) {
      height: auto;
    }
    ${props =>
      props.green &&
      `
        width: 100%;
        margin-bottom: 0;
    `}
  }

  @media screen and (max-width: 900px) and (max-height: 430px) {
    & > p {
      font-size: 1.1vw;
      line-height: 1.5;
    }
  }

  /* @media only screen and (min-width: 1000px) and (min-height: 900px) {
    &:nth-child(1) {
      height: 20vh;
    }
  } */
`

const TextCard = styled.p`
  font-size: ${size.XXXS};
  line-height: 0.8rem;
  white-space: pre-wrap;
  font-family: ${family.SpaceMono};
  text-align: left;
  width: 85%;
  text-transform: none;
  margin-bottom: 15px;
  &:nth-child(1) {
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 800px) {
    font-size: 12px;
    line-height: 18px;
    &:nth-child(1) {
      margin-bottom: 40px;
    }
  }
`

const GreenCardText = styled(TextCard)`
  background: rgb(119, 173, 123);
  background: linear-gradient(
    -90deg,
    rgba(119, 173, 123, 1) 35%,
    rgba(208, 213, 162, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: ${family.Alata};
  width: 90%;
  font-size: ${size.XS};
  line-height: 1.8rem;
  margin-bottom: 15px !important;
  @media only screen and (max-width: 800px) {
    text-align: center;
    font-size: 14px;
  }
`

const GreenCardTitle = styled(TextCard)`
  background: rgb(119, 173, 123);
  background: linear-gradient(
    -90deg,
    rgba(119, 173, 123, 1) 35%,
    rgba(208, 213, 162, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: ${family.Archivo};
  width: 90%;
  line-height: 1rem;
  font-size: ${size.S};
  &:nth-child(1) {
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 800px) {
    text-align: center;
    font-size: 14px;
  }
`

const RowContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  margin-bottom: 30px;
`

const TextCardPoint = styled(TextCard)`
  width: ${props => (props.green ? "90%" : "92%")};
  align-self: left;
  margin: 0;
  @media only screen and (max-width: 800px) {
    width: 80%;
  }
`

const TextCardNumber = styled.p`
  width: 8%;
  font-size: 80px;
  margin: 0;
  font-family: ${family.NATS};
  @media only screen and (max-width: 800px) {
    align-self: flex-start;
    margin-top: 15px;
  }
`

const ToggleText = styled.div`
  position: absolute;
  width: 100%;
  height: 100px;
  bottom: ${props => (props.big ? "0" : "10px")};
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 900px) and (max-height: 430px) {
    bottom: 0;
  }
`

const TurtleImg = styled.div`
  position: absolute;
  left: 3%;
  width: 15%;
  top: 20vh;
  @media only screen and (max-width: 600px) {
    position: relative;
    margin-top: 30px;
    width: 50%;
    top: unset;
  }

  @media only screen and (max-width: 800px) {
    position: relative;
    margin-top: 30px;
    width: 30%;
    top: unset;
  }

  /* @media only screen and (min-width: 1000px) and (min-height: 900px) { */
  /* top: 10vh; */
  /* } */
`

const FlowerImg = styled.div`
  width: 95%;
  margin-top: 100px;
  @media only screen and (max-width: 800px) {
    margin-bottom: 4vh;
    margin-top: 2vh;
    width: 90%;
  }
`

const HandImg = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 3%;
  @media only screen and (max-width: 800px) {
    top: 10px;
    right: 10px;
    width: 5%;
  }
`

const GreenToggle = styled.div`
  position: relative;
  border: 1.5px solid #77ad7b;
  box-sizing: border-box;
  border-radius: 3px;
  width: 80%;
  padding: 12px 20px;
  margin-bottom: 40px;
  overflow: hidden;
  transition: height 0.5s ease;
  height: ${props => (props.big ? `${props.height}px` : "60px")};
  @media only screen and (max-width: 800px) {
    padding: 17px 20px;
  }
`

const SeeMoreText = styled.p`
  font-family: "Alata", sans-serif;
  letter-spacing: 0.1em;
  color: #77ad7b;
  font-size: 12px;
  margin-bottom: 20px;
  font-weight: 800;
  @media only screen and (max-width: 800px) {
    font-weight: 100;
  }
`

const SeeMore = styled.div`
  position: absolute;
  right: 14px;
  top: 15px;
  width: 30px;
  height: 28px;
  border: 1.5px solid #77ad7b;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > svg {
    transition: transform 0.5s ease;
    transform: rotate(${props => (props.big ? "180deg" : "0")});
  }
`

const HiddenText = styled.p`
  font-size: ${size.XXS};
  line-height: 0.8rem;
  letter-spacing: 0.1em;
  font-family: ${family.SpaceMono};
  text-align: left;
  text-transform: none;
  &:nth-child(4) {
    margin-bottom: 0;
  }
  @media only screen and (max-width: 800px) {
    font-size: 11px;
    line-height: 15px;
    &:nth-child(2) {
      margin-bottom: 0;
    }
  }
`

const ToggleContainer = styled.div``

const LottieAnimation = styled.div`
  height: 100%;
  width: auto;
  &.animation-plus {
    ${props => (props.big ? "display: none;" : "display: block;")}
  }
  &.animation-moins {
    ${props => (props.big ? "display: block;" : "display: none;")}
  }
`

const Cadre = props => {
  const [isBig, setIsBig] = useState(false)
  const [cadreHeight, setCadreHeight] = useState()
  const text1 = props.text1
  const text2 = props.text2
  const id = props.id
  const { isMobile } = useContext(AppContext)
  const animationContainerMoins = createRef()
  const animationContainerPlus = createRef()

  const data = useStaticQuery(graphql`
    query {
      turtle: file(relativePath: { eq: "tortue.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      flowers: file(relativePath: { eq: "fleur_parterre.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      hand: file(relativePath: { eq: "hand.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const handleClick = () => {
    if (isBig) {
      setIsBig(false)
    } else {
      setIsBig(true)
    }
  }

  useEffect(() => {
    const $container1 = document.querySelector(`.${id}-container-1`)
    const $container2 = document.querySelector(`.${id}-container-2`)
    const $container3 = document.querySelector(`.${id}-container-3`)
    if ($container1 && $container2) {
      if (props.green) {
        const greenHeight = isMobile
          ? $container1.getBoundingClientRect().height +
            $container2.getBoundingClientRect().height +
            50
          : $container2.getBoundingClientRect().height +
            $container3.getBoundingClientRect().height
        setCadreHeight(greenHeight)
      } else {
        setCadreHeight(
          $container1.getBoundingClientRect().height +
            $container2.getBoundingClientRect().height +
            100
        )
      }
    }
    if (!props.green) {
      const animPlus = lottie.loadAnimation({
        container: animationContainerPlus.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationPlus,
      })
      const animMoins = lottie.loadAnimation({
        container: animationContainerMoins.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationMoins,
      })
      return () => {
        animPlus.destroy()
        animMoins.destroy()
      } // optional clean up for unmounting
    }
  }, [isMobile])

  return (
    <CadreContainer
      green={props.green}
      className={id}
      height={cadreHeight}
      baseHeight={(() => {
        // if (props.green && window.innerHeight > 900) return "30vh"
        if (props.green) return "55vh"
        else return "40vh"
      })()}
      big={isBig}
      isOffre={props.location.includes("offre")}
    >
      {props.green && (
        <>
          <HandImg>
            <Img loading="eager" fluid={data.hand.childImageSharp.fluid} />
          </HandImg>
          <TurtleImg>
            <Img loading="eager" fluid={data.turtle.childImageSharp.fluid} />
          </TurtleImg>
        </>
      )}
      <ContainerAnimate green={props.green}>
        {isMobile && props.green ? (
          <>
            <FlowerImg>
              <Img loading="eager" fluid={data.flowers.childImageSharp.fluid} />
            </FlowerImg>
            <TextCardContainer green={props.green}>
              <GreenCardTitle>{text1}</GreenCardTitle>
              <GreenCardText>{RichText.render(text2.titre)}</GreenCardText>
            </TextCardContainer>
            <GreenToggle green={props.green} height={cadreHeight} big={isBig}>
              <SeeMoreText
                onClick={handleClick}
                className={id + "-container-1"}
              >
                Lire + sur notre engagement
              </SeeMoreText>
              <SeeMore onClick={handleClick} big={isBig}>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.59017 7.46126L0.90868 2.1776C0.356194 1.55594 0.805211 0.57959 1.6437 0.57959H11.0067C11.1943 0.579431 11.3781 0.632685 11.5358 0.732973C11.6936 0.833261 11.8188 0.976333 11.8964 1.14506C11.9739 1.31378 12.0006 1.501 11.9732 1.6843C11.9457 1.8676 11.8654 2.0392 11.7417 2.17857L7.06021 7.46029C6.96859 7.56382 6.8556 7.64679 6.72883 7.70364C6.60205 7.76049 6.46443 7.7899 6.32519 7.7899C6.18595 7.7899 6.04833 7.76049 5.92155 7.70364C5.79478 7.64679 5.68179 7.56382 5.59017 7.46029V7.46126Z"
                    fill="#77AD7B"
                  />
                </svg>
              </SeeMore>
              <ToggleContainer className={id + "-container-2"}>
                <HiddenText>{text2.point1}</HiddenText>
                <HiddenText>{text2.point2}</HiddenText>
                {text2.point3 && <HiddenText>{text2.point3}</HiddenText>}
              </ToggleContainer>
            </GreenToggle>
          </>
        ) : (
          <>
            <TextCardContainer
              className={id + "-container-1"}
              green={props.green}
              big={isBig}
            >
              {props.green ? (
                <FlowerImg>
                  <Img
                    loading="eager"
                    fluid={data.flowers.childImageSharp.fluid}
                  />
                </FlowerImg>
              ) : (
                <p>{text1}</p>
              )}
            </TextCardContainer>
            <TextCardContainer
              className={id + "-container-2"}
              green={props.green}
            >
              {props.green ? (
                <>
                  <GreenToggle
                    green={props.green}
                    height={cadreHeight}
                    big={isBig}
                  >
                    <SeeMoreText
                      onClick={handleClick}
                      className={`${id}-container-1 click`}
                    >
                      lire + sur notre engagement
                    </SeeMoreText>
                    <SeeMore
                      className="click"
                      onClick={handleClick}
                      big={isBig}
                    >
                      <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.59017 7.46126L0.90868 2.1776C0.356194 1.55594 0.805211 0.57959 1.6437 0.57959H11.0067C11.1943 0.579431 11.3781 0.632685 11.5358 0.732973C11.6936 0.833261 11.8188 0.976333 11.8964 1.14506C11.9739 1.31378 12.0006 1.501 11.9732 1.6843C11.9457 1.8676 11.8654 2.0392 11.7417 2.17857L7.06021 7.46029C6.96859 7.56382 6.8556 7.64679 6.72883 7.70364C6.60205 7.76049 6.46443 7.7899 6.32519 7.7899C6.18595 7.7899 6.04833 7.76049 5.92155 7.70364C5.79478 7.64679 5.68179 7.56382 5.59017 7.46029V7.46126Z"
                          fill="#77AD7B"
                        />
                      </svg>
                    </SeeMore>
                    <ToggleContainer className={id + "-container-3"}>
                      <GreenCardTitle>{text1}</GreenCardTitle>
                      <GreenCardText>
                        {RichText.render(text2.titre)}
                      </GreenCardText>
                      <HiddenText>{text2.point1}</HiddenText>
                      <HiddenText>{text2.point2}</HiddenText>
                      {text2.point3 && <HiddenText>{text2.point3}</HiddenText>}
                    </ToggleContainer>
                  </GreenToggle>
                </>
              ) : (
                <>
                  <TextCard>{RichText.render(text2.titre)}</TextCard>
                  <RowContainer>
                    {<TextCardNumber>1</TextCardNumber>}
                    <TextCardPoint>{text2.point1}</TextCardPoint>
                  </RowContainer>
                  <RowContainer>
                    {<TextCardNumber>2</TextCardNumber>}
                    <TextCardPoint>{text2.point2}</TextCardPoint>
                  </RowContainer>
                  <RowContainer>
                    {<TextCardNumber>3</TextCardNumber>}
                    <TextCardPoint>{text2.point3}</TextCardPoint>
                  </RowContainer>
                </>
              )}
            </TextCardContainer>
          </>
        )}
      </ContainerAnimate>
      {!props.green && (
        <ToggleText onClick={handleClick} big={isBig}>
          <LottieAnimation
            className="animation-plus click"
            big={isBig}
            ref={animationContainerPlus}
          />
          <LottieAnimation
            className="animation-moins click"
            big={isBig}
            ref={animationContainerMoins}
          />
        </ToggleText>
      )}
    </CadreContainer>
  )
}

export default Cadre
